import React from 'react'
import { AccordionEventKey } from 'react-bootstrap/esm/AccordionContext'
import {
  StyledAccordionItem,
  SubsectionAccordionBody,
  SubsectionAccordionHeader,
  SubsectionAccordionHeaderGrid,
  SubSectionAccordionHeaderIconContainer,
  SubsectionAccordionHeaderNote,
  SubSectionAccordionHeaderTitleContainer,
} from './SubsectionAccordion.styles'

export const SubsectionAccordionHeaderContent = ({
  icon,
  title,
  note,
  $customGridLayout,
  alignTop,
}: {
  icon: JSX.Element
  title: string | JSX.Element
  note?: string | JSX.Element
  $customGridLayout?: string
  alignTop?: boolean
}): JSX.Element => {
  return (
    <SubsectionAccordionHeaderGrid
      $customGridLayout={$customGridLayout}
      $alignTop={alignTop}
    >
      <SubSectionAccordionHeaderIconContainer>
        {icon}
      </SubSectionAccordionHeaderIconContainer>
      <SubSectionAccordionHeaderTitleContainer>
        {title}
      </SubSectionAccordionHeaderTitleContainer>
      {note && (
        <SubsectionAccordionHeaderNote>{note}</SubsectionAccordionHeaderNote>
      )}
    </SubsectionAccordionHeaderGrid>
  )
}

export const SubsectionAccordionItemComponent = ({
  eventKey,
  icon,
  title,
  notes,
  body,
  customFooter,
  headerActions,
  handleHeaderClick,
  isDisabled,
  alwaysOpen,
  handleBodyClick,
  $customGridLayout,
  noBottomBorder,
  alignTop,
}: {
  eventKey: AccordionEventKey
  icon: JSX.Element
  title: string | JSX.Element
  notes?: string | JSX.Element
  body: JSX.Element
  customFooter?: JSX.Element
  headerActions?: JSX.Element
  handleHeaderClick?: (e: React.MouseEvent) => void
  isDisabled?: boolean
  alwaysOpen?: boolean
  handleBodyClick?: (e: React.MouseEvent) => void
  $customGridLayout?: string
  noBottomBorder?: boolean
  alignTop?: boolean
}): JSX.Element => (
  <StyledAccordionItem
    eventKey={eventKey as string}
    onClick={handleHeaderClick}
  >
    <SubsectionAccordionHeader
      $currentEventKey={eventKey}
      disabled={isDisabled}
      $noBottomBorder={noBottomBorder}
      $alignTop={alignTop}
      $headerActions={headerActions}
    >
      <SubsectionAccordionHeaderContent
        icon={icon}
        title={title}
        note={notes}
        $customGridLayout={$customGridLayout}
        alignTop={alignTop}
      />
    </SubsectionAccordionHeader>
    {(!isDisabled || alwaysOpen) && (
      <SubsectionAccordionBody
        onClick={handleBodyClick ? handleBodyClick : null}
      >
        {body}
      </SubsectionAccordionBody>
    )}
    {!!customFooter && customFooter}
  </StyledAccordionItem>
)
